import { Component, OnInit } from '@angular/core';
import { AgendaComponent } from '../agenda/agenda.component';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-carousel-destaques',
  templateUrl: './carousel-destaques.component.html',
  styleUrls: ['./carousel-destaques.component.scss'],
  standalone: true,
  imports: [CarouselModule, ButtonModule, TagModule, AgendaComponent],
  providers: []
})
export class CarouselDestaquesComponent implements OnInit {
  eventos: any[] = [];
  responsiveOptions: any[] | undefined;

  constructor() { }

  ngOnInit() {
    this.eventos = [
      {
        horario: 'Segunda a sexta - 17h',
        imagem: '/assets/images/beach-tenis.jpg',
        nome: 'Aulas de surf',
      },
      {
        horario: 'Segunda a sexta - 17h',
        imagem: '/assets/images/beach-tenis.jpg',
        nome: 'Aulas de beach tenis',
      },
      {
        horario: 'Segunda a sexta - 17h',
        imagem: '/assets/images/beach-tenis.jpg',
        nome: 'Aulas de futvôlei',
        local: 'Rua exemplo, 100 - Museu exemplar',
      },
      {
        horario: 'Segunda a sexta - 17h',
        imagem: '/assets/images/beach-tenis.jpg',
        nome: 'Aulas de surf infantil',
      },
      {
        horario: 'Segunda a sexta - 17h',
        imagem: '/assets/images/beach-tenis.jpg',
        nome: 'Aulas de surf',
      }
    ];

    this.responsiveOptions = [
      {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
      }
    ];
  }
}
